import { between, forbidExtraProps } from 'airbnb-prop-types';

import { range } from 'remeda';

import map from 'lodash/fp/map';
import random from 'lodash/fp/random';

import { theme } from '@prose-ui';
import { styled } from '@prose-ui/legacy';

import { Typography } from 'Components/Typography';

const StampGrid = styled('div')(({ rows, gutter, radius }) => ({
  margin: '0 auto',
  display: 'grid',
  maxWidth: `${(12 / rows) * radius + (12 / rows) * gutter}px`,
  justifyItems: 'center',
  textAlign: 'center',
  gridTemplateColumns: `repeat(auto-fill, ${radius + gutter}px)`,
}));

const Slot = styled('div')(({ radius, gutter }) => ({
  position: 'relative',
  backgroundColor: theme.colors.neutral[100],
  height: radius,
  width: radius,
  margin: gutter / 2,
  borderRadius: radius,
}));

const Stamp = styled('div')(({ /* index, */ radius, gutter }) => ({
  position: 'absolute',
  backgroundColor: theme.colors.highlight[200],
  height: radius,
  width: radius,
  margin: `${random(-gutter / 2, gutter / 2)}px ${random(-gutter / 2, gutter / 2)}px`,
  opacity: 0.7,
  borderRadius: radius,
  zIndex: 2,
}));

const SlotIndexTypography = styled(Typography)(({ radius }) => ({
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  lineHeight: `${radius}px`,
  textAlign: 'center',
  zIndex: 1,
}));

const FreeItemSlot = styled(Slot)(({ radius, gutter, rows }) => ({
  gridColumnStart: 12 / rows - 1,
  gridColumnEnd: 12 / rows + 1,
  width: radius * 2 + gutter,
}));

const FreeItemSlotTypography = styled(Typography)(({ radius }) => ({
  height: '100%',
  lineHeight: `${radius}px`,
}));

const PunchCard = ({ points, radius, gutter, rows }) => (
  <StampGrid gutter={gutter} radius={radius} rows={rows}>
    {map(
      index => (
        <Slot
          key={`stamped-slots-${index}`}
          className="hide-in-percy"
          gutter={gutter}
          radius={radius}
        >
          <SlotIndexTypography
            data-testid={`slot-${index}`}
            gutter={gutter}
            radius={radius}
            variant="mono1"
          >
            {index}
          </SlotIndexTypography>
          {index <= points && (
            <Stamp data-testid={`stamp-${index}`} gutter={gutter} index={index} radius={radius} />
          )}
        </Slot>
      ),
      range(1, 11) // from 1 to 10 included (11 excluded)
    )}
    <FreeItemSlot gutter={gutter} radius={radius} rows={rows}>
      <FreeItemSlotTypography gutter={gutter} radius={radius} variant="mono1">
        FREE ITEM
      </FreeItemSlotTypography>
    </FreeItemSlot>
  </StampGrid>
);

PunchCard.propTypes = forbidExtraProps({
  // Real life use : User has a variable number of points punched on his card
  points: between({ gte: 0, lte: 10 }),
  // Real life use : we want to change "resolution" of punchcard depending on device
  radius: between({ gte: 10, lte: 100 }),
  gutter: between({ gte: 10, lte: 100 }),
  // Real life use : we want to show a different number of rows depending on mobile / desktop
  rows: between({ gte: 2, lte: 4 }),
});

PunchCard.defaultProps = {
  points: 0,
  radius: 44,
  gutter: 25,
  rows: 2,
};

export default PunchCard;
